/*
    * Important information is highlighted
    ! Deprecated method, do not use
    ? Should this method be exposed in the public API?
    TODO: refactor this method so that it conforms to the API
*/
import * as $ from 'jquery'; // * go to node_modules and grab all from jquery module

// * FOUNDATION-SITES
import 'foundation-sites/dist/css/foundation.min.css';
import 'foundation-sites/dist/js/foundation.min.js';

// * SLICK-CAROUSEL
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick.js';

import '@js/windowLoad';
import '@js/header-menu';
import '@js/locations';
import '@js/scroll-to';
import '@js/search-bar';
import '@js/select-field';
import '@js/env-industry/search-products';
import '@js/env-industry/enquiry';
import closeMenuOnLink from '@js/graco/small-tweaks';
import '@js/small-tweaks';
import mapLocations from '@js/we-operate';
import searchProducts from '@js/env-industry/search-products';
import scrollToCategory from '@js/scroll-to';

import '@scss/main.scss';

const makeSlick = (slickTarget, autoplay) => {
    const slidesCount = $('.slides-count');
    const slickCarouselSlidesCount = $(`${slickTarget}--slide`).length;
    let currentSlickCarouselSlide;

    $(slickTarget).slick({
        dots: true,
        infinite: true,
        speed: 500,
        fade: true,
        cssEase: 'linear',
        prevArrow: $('.slick-prev'),
        nextArrow: $('.slick-next'),
        appendDots: '.slide-dots',
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay,
        autoplaySpeed: 8000
      }).on('afterChange', () => {
        currentSlickCarouselSlide = $('.slick-current').find(`${slickTarget}--slide`).attr('data-frame');
        slidesCount.html(`0${currentSlickCarouselSlide}<span>/0${slickCarouselSlidesCount}</span>`);
      });
  
      $('.slick-next, .slick-prev, .slick-dots > li').on('click', () => {
        currentSlickCarouselSlide = $('.slick-current').find(`${slickTarget}--slide`).attr('data-frame');
        slidesCount.html(`0${currentSlickCarouselSlide}<span>/0${slickCarouselSlidesCount}</span>`);
      });
  
      // * on swipe/drag event
      $(slickTarget).on('swipe', function(event, slick, direction) {
        currentSlickCarouselSlide = $('.slick-current').find(`${slickTarget}--slide`).attr('data-frame');
        slidesCount.html(`0${currentSlickCarouselSlide}<span>/0${slickCarouselSlidesCount}</span>`);
      });
  
      // * initial setting
      slidesCount.html(`01<span>/0${slickCarouselSlidesCount}</span>`);
}

const slickNews = (selector, dataPerPage) => {
    console.warn(dataPerPage)
    $(selector).slick({
        accessibility: true,
        slidesToShow: dataPerPage,
        slidesToScroll: dataPerPage,
        adaptiveHeight: true,
        prevArrow: '<div class="news-btn-arrow news-btn-arrow--left"></div>',
        nextArrow: '<div class="news-btn-arrow news-btn-arrow--right"></div>',
        responsive: [
        {
            breakpoint: 600,
            settings: {
            slidesToShow: 1,
            slidesToScroll: 1
            }
        }
        ]
    })
}

window.addEventListener('DOMContentLoaded', () => {
    $(document).foundation();

    setTimeout(() => {
        $(".current-menu-item").closest("li").addClass("is-active");
    }, 100);

    if ($(window).width() >= 1080) {
        $('.header-menu .accordion').foundation('destroy');
    }

    $(window).on('resize', () => {
        let windowWidth = $(window).width();
        if (windowWidth >= 1080 && $('.accordion[data-accordion]').length !== 0) {
            $('.header-menu .accordion').foundation('destroy');
        }
    });
    
    if ($(window).width() < 1080) {
        $('.accordion-item > a.current-menu-parent').trigger('click');
    }

    scrollToCategory();

    searchProducts.initialState();

    closeMenuOnLink();
    mapLocations();
    
    makeSlick('.header__slick-carousel', true);
    if ($('.menu-Casb').length > 0) {
        const slidesCount = $('.page-slick-carousel__slides--slide').length;
        
        if (slidesCount < 2) {
            $('.slick-prev').hide();
            $('.slick-next').hide();
        }

        $('.page-slick-carousel__slides').slick({
            dots: true,
            infinite: true,
            speed: 500,
            fade: true,
            cssEase: 'linear',
            prevArrow: $('.slick-prev'),
            nextArrow: $('.slick-next'),
            appendDots: '.slide-dots',
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            autoplaySpeed: 4000
        })
    }

    if ($('.theme-1-wrapper').length !== 0 && $('.theme-1-wrapper').hasClass('slick-enabled')) {
        const dataPerPage = Number($('.theme-1-wrapper').attr('data-per-page'));
        slickNews('.theme-1-wrapper', dataPerPage);
    } else if ($('.theme-2-wrapper').length !== 0 && $('.theme-2-wrapper').hasClass('slick-enabled')) {
        const dataPerPage = Number($('.theme-2-wrapper').attr('data-per-page'));
        slickNews('.theme-2-wrapper', dataPerPage);
    }
});